import { c as _c } from "react/compiler-runtime";
import type { GetBlockErrorType } from 'viem';
import { ZERO } from '@morpho-org/dapp-core';
import type { InterfaceOperation } from '@/operations/operations.types';
import { useWeb3Context } from '@/contexts/Web3Context';
import useFinalizeLabel from '../useFinalizeLabel';
interface PositionManagerDialogLabelsProps {
  operationLabel: string;
  inputLoanAmount: bigint;
  inputCollateralAmount: bigint;
  isNew: boolean;
  localErrorMessage?: string;
  operations: InterfaceOperation[];
  simulationError?: Error;
  blockError: GetBlockErrorType | null;
  isPending: boolean;
}

/**
 * Generates button labels for position manager market dialogs based on operation state.
 * @param props - Dialog configuration including operation amounts and state
 * @returns Object with bundler and confirm button labels
 */
function usePositionManagerMarketDialogLabels(t0) {
  const $ = _c(12);
  const {
    operationLabel,
    inputLoanAmount,
    inputCollateralAmount,
    isNew,
    localErrorMessage,
    operations,
    simulationError,
    blockError,
    isPending
  } = t0;
  const {
    account
  } = useWeb3Context();
  const t1 = inputLoanAmount === ZERO && inputCollateralAmount === ZERO;
  let t2;
  if ($[0] !== account.isWrongChain || $[1] !== blockError || $[2] !== isNew || $[3] !== isPending || $[4] !== localErrorMessage || $[5] !== operationLabel || $[6] !== operations || $[7] !== simulationError || $[8] !== t1) {
    t2 = {
      operationLabel,
      isInitialState: t1,
      isNew,
      isEditing: false,
      localErrorMessage,
      operations,
      simulationError,
      blockError,
      isPending,
      isWrongChain: account.isWrongChain,
      hasDisabledMessage: false,
      noReviewPrefix: true
    };
    $[0] = account.isWrongChain;
    $[1] = blockError;
    $[2] = isNew;
    $[3] = isPending;
    $[4] = localErrorMessage;
    $[5] = operationLabel;
    $[6] = operations;
    $[7] = simulationError;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const confirmButtonLabel = useFinalizeLabel(t2);
  let t3;
  if ($[10] !== confirmButtonLabel) {
    t3 = {
      confirmButtonLabel
    };
    $[10] = confirmButtonLabel;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export default usePositionManagerMarketDialogLabels;